import React from 'react'
import {NavLink, useNavigate} from 'react-router-dom'
import {Tooltip} from 'react-tooltip'
import {useEyeconxStore} from '../../../store/eyeconxStore'

function NavItem({to, icon, label, activeClass, collapsed, badge}) {
    const link = (
        <NavLink
            to={to}
            className={({isActive}) =>
                `nav-link rounded-3 d-flex align-items-center py-2 px-2 ${
                    collapsed ? 'justify-content-center position-relative' : ''
                } ${isActive ? activeClass : 'text-dark hover-bg-light'}`
            }
            data-tooltip-id={collapsed ? `sms-nav-${to}` : undefined}
            data-tooltip-content={collapsed ? label : undefined}
            data-tooltip-place="right"
        >
            <i className={`bi ${icon} fs-5 ${collapsed ? '' : 'me-3'}`}></i>
            {!collapsed && <span>{label}</span>}
            {badge > 0 && (
                <span
                    className={`badge rounded-pill bg-success ${collapsed ? 'position-absolute top-0 start-100 translate-middle' : 'ms-auto'}`}
                    style={{fontSize: '0.65rem'}}
                >
                    {badge}
                </span>
            )}
        </NavLink>
    )

    return (
        <li className="nav-item">
            {link}
            {collapsed && <Tooltip id={`sms-nav-${to}`}/>}
        </li>
    )
}

function SmsSide({collapsed = false}) {
    const logout = useEyeconxStore((state) => state.logout)
    const smsInbox = useEyeconxStore((state) => state.smsInbox)
    const toggleSmsSidebarCollapsed = useEyeconxStore((state) => state.toggleSmsSidebarCollapsed)
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
        navigate('/login')
    }

    return (
        <div className={`sms-sidebar-inner ${collapsed ? 'sms-sidebar--collapsed' : ''}`}>
            <div className="sms-sidebar-header">
                <div className="sms-sidebar-logo">
                    {collapsed ? (
                        <span className="sms-sidebar-logo-compact d-inline-flex align-items-center justify-content-center">
                            E
                        </span>
                    ) : (
                        <img
                            src="media/logos2/neweyeconxlogo.png"
                            alt="EyeconX"
                            className="img-fluid"
                        />
                    )}
                </div>
                <button
                    type="button"
                    className="sms-sidebar-toggle"
                    onClick={toggleSmsSidebarCollapsed}
                    aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                    title={collapsed ? 'Expand menu' : 'Collapse menu'}
                >
                    <i className={`bi ${collapsed ? 'bi-chevron-right' : 'bi-chevron-left'}`}></i>
                </button>
            </div>

            <hr className="mx-2 my-0"/>

            <nav className="sms-sidebar-nav">
                <ul className="nav nav-pills flex-column mb-auto mt-2 gap-1">
                    <NavItem
                        to="sms-dashboard"
                        icon="bi-speedometer2"
                        label="Dashboard"
                        activeClass="bg-primary bg-opacity-10 text-primary fw-medium"
                        collapsed={collapsed}
                    />
                    <NavItem
                        to="sms-messages"
                        icon="bi-chat-left-text"
                        label="Messages"
                        activeClass="bg-success bg-opacity-10 text-success fw-medium"
                        collapsed={collapsed}
                        badge={smsInbox}
                    />
                    <NavItem
                        to="sms-clinic-settings"
                        icon="bi-gear"
                        label="Settings"
                        activeClass="bg-info bg-opacity-10 text-info fw-medium"
                        collapsed={collapsed}
                    />
                </ul>
            </nav>

            <div className="sms-sidebar-footer">
                <hr className="mx-1"/>
                <ul className="nav nav-pills flex-column mb-2 gap-1">
                    <NavItem
                        to="sms-help"
                        icon="bi-life-preserver"
                        label="Help & Support"
                        activeClass="bg-primary bg-opacity-10 text-primary fw-medium"
                        collapsed={collapsed}
                    />
                </ul>
                <button
                    type="button"
                    onClick={handleLogout}
                    className={`btn btn-outline-danger w-100 py-2 d-flex align-items-center ${
                        collapsed ? 'justify-content-center' : 'justify-content-center'
                    }`}
                >
                    {!collapsed && <span>Logout</span>}
                    <i className={`bi bi-box-arrow-right ${collapsed ? '' : 'ms-2'}`}></i>
                </button>

                {!collapsed && (
                    <div className="text-muted text-center mt-3 mb-1">
                        <small className="text-muted" style={{fontSize: '0.7rem'}}>
                            {new Date().getFullYear()} &copy; EyeconX
                        </small>
                    </div>
                )}
            </div>
        </div>
    )
}

export default SmsSide
